(function () {
  function isDesktop() {
    return window.matchMedia("(min-width: 769px)").matches;
  }

  function isVisible(el) {
    if (!el) return false;
    return window.getComputedStyle(el).display !== "none";
  }

  function loadVisibleBookingMood() {
    document.querySelectorAll(".loven-dates__embed iframe[data-src]").forEach(function (iframe) {
      if (iframe.getAttribute("src")) return;
      var hideRoot = iframe.closest(".small--hide, .medium-up--hide, .loven-product__aside");
      if (hideRoot && !isVisible(hideRoot)) return;
      iframe.src = iframe.getAttribute("data-src");
    });
  }

  function headerOffset() {
    var header = document.querySelector(".site-header");
    if (!header) return 72;
    return Math.round(header.getBoundingClientRect().height) + 8;
  }

  function scrollToCalendar(event) {
    var target = document.getElementById("calendar");
    if (!target) return;
    event.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  function initStickyBar() {
    var bar = document.querySelector("[data-loven-sticky-bar]");
    var calendar = document.getElementById("calendar");
    if (!bar || !calendar) return;

    var cta = bar.querySelector('a[href="#calendar"]');
    if (cta) cta.addEventListener("click", scrollToCalendar);

    if (isDesktop() || typeof IntersectionObserver === "undefined") return;

    var panel = calendar.querySelector(".loven-dates") || calendar;
    var observer = new IntersectionObserver(
      function (entries) {
        var hidden = entries[0].isIntersecting;
        bar.classList.toggle("is-hidden", hidden);
        document.body.classList.toggle("loven-sticky-bar-hidden", hidden);
      },
      { threshold: 0.12, rootMargin: "0px 0px -72px 0px" }
    );
    observer.observe(panel);
  }

  function toggleReadMore(btn) {
    var container = btn.closest(".read-more-container");
    if (!container) return;
    var expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    container.classList.toggle("is-open", !expanded);
  }

  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".read-more-btn");
    if (!btn) return;
    event.preventDefault();
    toggleReadMore(btn);
  });

  loadVisibleBookingMood();
  initStickyBar();
  window.addEventListener("resize", loadVisibleBookingMood);
})();
